class ChangePasswordFormValidation {
  _passwordsDoNotMatchMessage = '';

  constructor(passwordsDoNotMatchMessage) {
    this._passwordsDoNotMatchMessage = passwordsDoNotMatchMessage;

    this.validateSync = this.validateSync.bind(this);
  }

  validateSync(values, errors) {
    let result = values.captchaVerified;
    if (values.newPasswordConfirmation !== values.newPassword) {
      result = false;

      if (!errors.newPasswordConfirmation) {
        errors.newPasswordConfirmation = this._passwordsDoNotMatchMessage;
      }
    } else {
      // TODO: check if there is a better way to clear _passwordsDoNotMatchMessage errors
      if (errors.newPasswordConfirmation === this._passwordsDoNotMatchMessage) {
        errors.newPasswordConfirmation = null;
      }
    }

    return result;
  }
}

export default ChangePasswordFormValidation;



// WEBPACK FOOTER //
// ./src/containers/MyAccount/ChangePassword/formValidation.js